import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getActiveBenefits } from '@epi-actions/api';
import { fetchGet } from '@epi-helpers/FetchHelpers';
import { companyDirectBenefitTypes } from '@epi-repositories/BenefitGroupSettingsRepository';
import { showNotification } from '@epi-actions/overlays';
import { IBenefits } from '@epi-models/containers/ManageBenefits';

export const useTopup = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [activeBenefits, setActiveBenefits] = useState<never[] | IBenefits[]>(
    []
  );

  const sortBenefitsInOrder = (benefits: IBenefits[]): IBenefits[] => {
    const orderMap = {
      recreational: 1,
      transport: 2,
      massage: 3,
      wellbeing: 4
    };

    return [...benefits]
      .map(elem => elem.toLowerCase())
      .sort((a, b) => {
        const orderA = orderMap[a] || 999;
        const orderB = orderMap[b] || 999;
        return orderA - orderB;
      }) as IBenefits[];
  };

  const onSuccess = res => {
    setActiveBenefits(sortBenefitsInOrder(res));
    setIsLoading(false);
  };

  const onFailure = () => {
    dispatch(showNotification({ message: 'messages.error' }, 'error'));
    setIsLoading(false);
  };

  useEffect(() => {
    dispatch(getActiveBenefits());
  }, []);

  useEffect(() => {
    fetchGet(companyDirectBenefitTypes, {}, onSuccess, onFailure);
  }, []);

  return {
    hasLoadableBenefit: !!activeBenefits.length,
    isLoading,
    activeBenefits
  };
};
